<template>
    <div>
        <headline-container headline="Edit Untracked Email Address" :breadcrumbs="breadcrumbs">
            <button type="button" class="btn btn-white pull-right" @click="destroy">
                <i class="fa fa-trash"></i> Delete
            </button>
        </headline-container>

        <loading-container v-if="loading"></loading-container>

        <div v-else class="container">
            <div class="row">
                <div class="col-xs-6">
                    <help-text>
                        <h3>
                            Edit Untracked Email Address
                        </h3>

                        <p>
                            Enter the details of the untracked email address. When saved, the system will not track
                            email to or from the given address.
                        </p>
                    </help-text>
                </div>

                <div class="col-xs-18">
                    <div class="panel panel-default">
                        <div class="panel-body">
                            <form @submit.prevent="submit" class="form-horizontal">
                                <text-form-group
                                        v-model="data.address"
                                        name="address"
                                        label="Address"
                                        :error="getError('address')"
                                ></text-form-group>

                                <hr>

                                <submit-form-group button-class="btn-black"></submit-form-group>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import modal from '@/modal'
    import notify from '@/notify'
    import Errors from '@/mixins/Errors'
    import HeadlineContainer from '@/components/Layout/HeadlineContainer'
    import HelpText from '@/components/HelpText'
    import LoadingContainer from '@/components/Layout/LoadingContainer'
    import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
    import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

    export default {
        components: {HeadlineContainer, HelpText, LoadingContainer, SubmitFormGroup, TextFormGroup},

        mixins: [Errors],

        props: ['id'],

        data() {
            return {
                data: null,

                loading: true
            }
        },

        mounted() {
            this.load()
        },

        computed: {
            breadcrumbs() {
                return [
                    {url: '/untracked-email-addresses', text: 'Untracked Email Addresses'},
                    {text: 'Edit'}
                ]
            }
        },

        methods: {
            load() {
                http.get('/api/v2/untracked-email-addresses/' + this.id).then(response => {
                    this.data = {...response.data.data.attributes}

                    this.loading = false
                })
            },

            submit() {
                http.put('/api/v2/untracked-email-addresses/' + this.id, this.data)
                    .then(() => {
                        notify.success('The untracked email address was saved')

                        this.$router.push('/untracked-email-addresses')
                    })
                    .catch(this.catchValidationErrors)
            },

            destroy() {
                modal.confirm('Are you sure that you want to delete the untracked email address?', () => {
                    http.delete('/api/v2/untracked-email-addresses/' + this.id)
                        .then(() => {
                            notify.success('The untracked email address was deleted')

                            this.$router.push('/untracked-email-addresses')
                        })
                })
            }
        }
    }
</script>
